module.exports = __webpack_public_path__ + "static/media/cocktail.0492dbe9.png";